import type { CrawlJobStatusCountDTO } from '@liks/lac-svc-api/esm/models/index';

const CRAWL_STATUS_ORDER = [
  'MAPPING',
  'AWAITING_SELECTION',
  'CRAWLING',
  'PROCESSING',
  'COMPLETED',
  'FAILED',
] as const;

const CRAWL_STATUS_ORDER_INDEX = new Map<string, number>(
  CRAWL_STATUS_ORDER.map((status, index) => [status, index]),
);

export function sumCrawlJobStatusCounts(
  items: Array<{ count?: number | null }> | null | undefined,
): number {
  if (!items) {
    return 0;
  }

  return items.reduce((total, item) => total + (item.count ?? 0), 0);
}

export function sortCrawlJobStatusCounts(
  items: CrawlJobStatusCountDTO[],
): CrawlJobStatusCountDTO[] {
  return [...items].sort((left, right) => {
    const leftStatus = left.status?.trim().toUpperCase() ?? '';
    const rightStatus = right.status?.trim().toUpperCase() ?? '';
    const leftOrder = CRAWL_STATUS_ORDER_INDEX.get(leftStatus);
    const rightOrder = CRAWL_STATUS_ORDER_INDEX.get(rightStatus);

    if (leftOrder != null && rightOrder != null) {
      return leftOrder - rightOrder;
    }
    if (leftOrder != null) {
      return -1;
    }
    if (rightOrder != null) {
      return 1;
    }
    return leftStatus.localeCompare(rightStatus, undefined, {
      sensitivity: 'base',
    });
  });
}

export function formatCrawlJobStatusLabel(
  status: string | null | undefined,
  translate: (key: string) => string,
): string {
  const normalized = status?.trim().toUpperCase() ?? '';
  if (normalized === '') {
    return translate('lac.websiteCrawls.statusUnknown');
  }

  const key = `knowledge.crawlStatus.${normalized}`;
  const translated = translate(key);
  return translated === key ? normalized : translated;
}

export function crawlStatusClassSuffix(
  status: string | null | undefined,
): string {
  return (status ?? 'unknown').trim().toLowerCase() || 'unknown';
}
